module.exports = __webpack_public_path__ + "img/logo_cars_01.6a6f93c6.png";